import Form from './Form';
import HtmlEncodingDecodingHelper from './HtmlEncodingDecodingHelper';
import NavigationHelper from './NavigationHelper';
import UrlHelper from './UrlHelper';

export default {
    Form,
    // unused: HtmlEncodingDecodingHelper,
    htmlEncodingDecoding: new HtmlEncodingDecodingHelper(),
    // unused: NavigationHelper,
    navigation: new NavigationHelper('/navigation'),
    // unused: UrlHelper,
    url: new UrlHelper()
}
